export const redirectToLogin = (): void => {
  if (typeof window !== "undefined") {
    sessionStorage.setItem("previous-page", window.location.pathname);
    window.location.href = "/login";
  }
};
